import { Link } from "react-router-dom"
import {getIcon, proxyImage} from "../functions"
import folderImg from "../images/full-folder.png"
import folderPublicImg from "../images/public-full-folder.png"
import linkImg from "../images/link-logo-search.jpg"
import noteImg from "../images/note-4.png"
import { PathLineClass } from "./PathLineClass"

export const SearchResultItem = ({
                                     item,
                                     type,
                                     isPublic = false,
                                     isGoogle = false,
                                     lang,
                                     requestSearch
                                 }) => {

    // Выбор картинки
    let img
    if (type === 'folder' || type === 'google-folder') {
        if (isPublic) {
            img = folderPublicImg
        } else {
            img = folderImg
        }
    } else if (type === 'note') {
        img = noteImg
    } else if (type === 'link') {
        if (item['thumbUrl']) {
            img = item['thumbUrl']
        }
        if (!img) img = getIcon(item.from, linkImg)
    } else if (type === 'google-file') {
        img = proxyImage(item['thumbUrl'])
        if (!img) img = getIcon(item['webViewLink'], linkImg)
    }
    if (!img) img = linkImg

    // Безопасный path
    const path = Array.isArray(item.path) ? item.path.slice(0, -1) : []

    // Безопасный parentFolder
    let parent = 'root'
    if (item && item.parents && item.parents[0]) parent = item.parents[0]
    const parentFolder = item.parentFolder || parent

    // Формируем правильную базовую часть ссылки
    const basePath = isGoogle ? "google-drive" : "folder"
    const openType = isPublic ? "open-public" : "open"

    return (
        <div className="bg-light rounded-1 border mt-2">
            <PathLineClass documents={{ path }} search />
            <Link
                to={`/${lang}/${basePath}/${openType}/${parentFolder}?filter=${requestSearch}`}
                className="text-decoration-none"
            >
                <button className="w-100 item-search d-flex btn btn-light rounded-0 overflow-hidden">
                    <img src={img} className="img-search rounded-4" alt="" />
                    <div className="mt-2 pt-2">
                        <p className="fs-5 ms-3 mb-2 text-black text-nowrap">
                            {item.name || "Без названия"}
                        </p>
                    </div>
                </button>
            </Link>
        </div>
    )
}
